import { api } from "@/services/api"

// ═══════════════════════════════════════════════════════════════════
//  REASSIGN OPTIONS
//
//  Who an appointment could be moved to (AB#768). Mirrors
//  GET api/ams/bookings/{uid}/reassign-options; every rule is the server's
//  (ReassignOptionRules.cs) — the WebUI lists what it says, available staff
//  first, and the rest with the reason it gave.
// ═══════════════════════════════════════════════════════════════════

/** Why a member of staff cannot take the appointment, as ReassignOptionReasons spells it. */
export type ReassignOptionReason = "booked" | "away" | "not-scheduled" | "daily-cap"

/** Matches ReassignOption. `calUserId` is Cal's id, which is what the reassign takes. */
export interface ReassignOption {
  calUserId: number
  name: string
  /** Can take it without an override. */
  available: boolean
  /** Null when available. */
  reason?: ReassignOptionReason | null
  /** The override's note, for `away`. */
  note?: string | null
}

/** Matches ReassignOptionsDto: available first, then the rest, each by name — the server's order. */
export interface ReassignOptions {
  options: ReassignOption[]
}

// "AmsBookings" so a move (which invalidates it) refetches the list should the dialog still be open.
const taggedApi = api.enhanceEndpoints({ addTagTypes: ["AmsBookings"] })

export const reassignApi = taggedApi.injectEndpoints({
  endpoints: (builder) => ({
    /** Not cached across opens: who is free, away or at their cap changes by the minute. */
    getReassignOptions: builder.query<ReassignOptions, string>({
      query: (bookingUid) => `/api/ams/bookings/${encodeURIComponent(bookingUid)}/reassign-options`,
      keepUnusedDataFor: 0,
      providesTags: ["AmsBookings"],
    }),
  }),
})

export const { useGetReassignOptionsQuery } = reassignApi
